/* ════════════════════════════════════════════════════════════════════════
   GOB SMOOTH — V152, 2026-10-19
   The Club price "Gentle roll", applied to the rest of the shop.

   Measured on the live site before this file (iPhone 13 profile, 4x CPU),
   ONE tap on Add to cart produced 12 cart writes over 7 seconds:
   4x /cart/add.js for Shipping Insurance + Extended Warranty, 2x /cart/change.js
   to undo the duplicates, 3x /cart/update.js for the two switches, and 5 drawer
   rebuilds — the photo flickered and the subtotal stepped 69,99 → 71,98 →
   73,97 → 75,96 → 73,97. The cause was three scripts racing each other:
   theme.js updateShippingInsurance / updateExtendedWarranty (on every drawer
   paint), the add-on reconcile block in gob-cart-drawer.js, and the switch
   change handlers that call both again.

   1. ADD-ONS — one queue. Shipping Insurance and Extended Warranty stay
      PRE-TICKED exactly as before; they are added once, together, in one
      request, and the two cart attributes (wf-switch / xw-switch) are written
      in one request. Every old entry point now calls GOBSmooth.syncAddons().
   2. DRAWER — rebuilds are coalesced (a burst of events = one fetch) and
      morphed: unchanged rows are kept (no image flicker), new rows grow in,
      removed rows fold away, the subtotal rolls like the Club price.
   3. ADD TO CART — the drawer opens on the tap with the kit already in it
      ("Adding to your cart…"); the button reads Adding… → ✓ Added. The add-ons
      are written before the drawer paints, so it paints once, correct.
   4. POPUP BUDGET — window.GOBPop: one interruption per visit, never while
      the drawer is open, never within 30 s of an add to cart. Used by
      gob-treat20.js (Halloween) and gob-geo.js (store bar).
   prefers-reduced-motion: no animation anywhere, behaviour unchanged.
   Styles: assets/gob-smooth.css. Loaded by snippets/gob-smooth-head.liquid.
   ════════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';
  if (window.GOBSmooth) return;

  var W = window, D = document, H = D.documentElement;
  var G = W.GOBSmooth = { v: 152, lastAdd: 0 };
  var RM = W.matchMedia ? W.matchMedia('(prefers-reduced-motion: reduce)') : null;
  function calm() { return !!(RM && RM.matches) || !Element.prototype.animate; }
  var EASE = 'cubic-bezier(.25,.1,.25,1)', OUT = 'cubic-bezier(.4,0,.2,1)';

  function q(s, r) { return (r || D).querySelector(s); }
  function qa(s, r) { return [].slice.call((r || D).querySelectorAll(s)); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function emit(name, detail) { try { D.dispatchEvent(new CustomEvent(name, { detail: detail || {}, bubbles: true })); } catch (e) {} }
  function ssGet(k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } }
  function ssSet(k, v) { try { sessionStorage.setItem(k, v); } catch (e) {} }

  /* ───────────────────────── 4. popup budget ───────────────────────── */
  var Pop = W.GOBPop = W.GOBPop || {
    _mem: '',
    owner: function () { return ssGet('gob_pop') || Pop._mem || ''; },
    free: function (name) { var o = Pop.owner(); return !o || o === name; },
    busy: function () {
      if (H.classList.contains('cart-open') || H.classList.contains('gob-cart-lock')) return true;
      return !!(G.lastAdd && Date.now() - G.lastAdd < 30000);
    },
    take: function (name) { if (!Pop.free(name)) return false; Pop._mem = name; ssSet('gob_pop', name); return true; }
  };

  /* ───────────────────────── network ───────────────────────── */
  function routes() {
    var r = (W.theme && W.theme.routes) || {};
    var root = ((W.Shopify && Shopify.routes && Shopify.routes.root) || '/').replace(/\/?$/, '/');
    var change = r.cartChange || root + 'cart/change.js';
    return { cart: r.cart || root + 'cart.js', add: r.cartAdd || root + 'cart/add.js', update: change.replace(/change\.js$/, 'update.js') };
  }
  /* A fresh read. XHR on purpose: the cart guard caches fetch('/cart.js') for
     800 ms, and a stale cart is exactly how the add-ons got added twice. */
  function readCart() {
    return new Promise(function (res) {
      try {
        var u = routes().cart, x = new XMLHttpRequest();
        x.open('GET', u + (u.indexOf('?') < 0 ? '?' : '&') + 'gs=' + Date.now(), true);
        x.setRequestHeader('Accept', 'application/json');
        x.timeout = 8000;
        x.onload = function () { try { res(x.status < 400 ? JSON.parse(x.responseText) : null); } catch (e) { res(null); } };
        x.onerror = x.ontimeout = function () { res(null); };
        x.send();
      } catch (e) { res(null); }
    });
  }
  function post(u, body) {
    return fetch(u, {
      method: 'POST', credentials: 'same-origin', body: JSON.stringify(body),
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
    }).then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
  }

  /* ───────────────────────── 1. add-ons, one queue ───────────────────────── */
  var CLUB_PRODUCT = 10601114403149, CLUB_VARIANT = 53631345131853;
  var EXTRA = /shipping\s*insurance|extended\s*warranty|gob club membership/i;
  function addons() {
    var s = W.themeSettings || {};
    return [
      { v: +s.shipping_insurance_product_id || 0, cb: 'wf_switch_btn', attr: 'wf-switch', row: 'worry_free' },
      { v: +s.extended_warranty_product_id || 0, cb: 'xw_switch_btn', attr: 'xw-switch', row: 'extended_warranty' }
    ].filter(function (a) { return a.v; });
  }
  function isExtra(i, list) {
    for (var k = 0; k < list.length; k++) if (i.variant_id === list[k].v) return true;
    return i.product_id === CLUB_PRODUCT || i.variant_id === CLUB_VARIANT || EXTRA.test(i.product_title || i.title || '');
  }

  /* opts.cart: a cart read already in flight (Add to cart reads it in parallel
     with its own write). opts.real: a kit is known to be in the cart.
     opts.later: leave the two attributes for the next pass — they never change
     what the drawer shows, so they need not hold up its first paint. */
  function runSync(opts) {
    opts = opts || {};
    var list = addons();
    if (!list.length) return Promise.resolve(false);
    /* V153: a cart read on the tap is only trusted if no add-on write has
       happened since — otherwise read again (a queued pass may have added them) */
    var fresh = !opts.cart || (G.writes || 0) !== opts.w0;
    return (fresh ? readCart() : opts.cart).then(function (cart) {
      if (!cart || !cart.items) return false;
      if (fresh) { G.lastCart = cart; G.lastCartAt = Date.now(); }
      var real = !!opts.real || cart.items.some(function (i) { return !isExtra(i, list); });
      var adds = [], updates = {}, attrs = {}, nU = 0, nA = 0;
      list.forEach(function (a) {
        var cb = D.getElementById(a.cb);
        var on = cb ? !!cb.checked : true;                    /* pre-ticked unless the shopper unticks */
        var lines = cart.items.filter(function (i) { return i.variant_id === a.v; });
        if (real && on) {
          if (!lines.length) adds.push({ id: a.v, quantity: 1, properties: { _skip_pixel: 'true' } });
          else {
            if (lines[0].quantity !== 1) { updates[lines[0].key] = 1; nU++; }
            for (var k = 1; k < lines.length; k++) { updates[lines[k].key] = 0; nU++; }
          }
        } else {
          lines.forEach(function (l) { updates[l.key] = 0; nU++; });   /* never carry a paid add-on without a kit */
        }
        var want = on ? 'true' : 'false';
        var hid = D.querySelector('input[name="attributes[' + a.attr + ']"]');
        if (hid && hid.value !== want) hid.value = want;
        /* no write on an empty cart: a page view must not create a cart */
        if (real && cb && !opts.later && (cart.attributes || {})[a.attr] !== want) { attrs[a.attr] = want; nA++; }
        var box = D.getElementById(a.row);
        if (box) { var d = real ? 'flex' : 'none'; if (box.style.display !== d) box.style.display = d; }
      });
      var wrote = false, p = Promise.resolve();        /* wrote = the lines changed */
      if (adds.length || nU || nA) G.writes = (G.writes || 0) + 1;
      if (adds.length) p = p.then(function () { return post(routes().add, { items: adds }).then(function (r) { if (r) wrote = true; }); });
      if (nU || nA) p = p.then(function () {
        var body = {};
        if (nU) body.updates = updates;
        if (nA) body.attributes = attrs;
        return post(routes().update, body).then(function (r) { if (r && nU) wrote = true; });
      });
      return p.then(function () { return wrote; });
    });
  }
  /* Removing the last kit: which add-on lines should go in the same request.
     Uses the cart read by the last drawer paint; null when unsure. */
  G.extrasFor = function (key) {
    var c = G.lastCart, list = addons();
    if (!c || !c.items || !list.length || Date.now() - (G.lastCartAt || 0) > 120000) return null;
    var line = c.items.filter(function (i) { return i.key === key; })[0];
    if (!line || isExtra(line, list)) return null;
    if (c.items.some(function (i) { return i.key !== key && !isExtra(i, list); })) return null;
    var u = {}, n = 0;
    u[key] = 0;
    c.items.forEach(function (i) { if (list.some(function (a) { return a.v === i.variant_id; })) { u[i.key] = 0; n++; } });
    return n ? u : null;
  };

  var chain = Promise.resolve(), queued = null, queuedSilent = true;
  /* Serialised and coalesced: calls made while one is waiting share it. */
  G.syncAddons = function (silent, opts) {
    if (opts) {                                   /* a specific pass: never folded into another */
      var own = chain.then(function () { return runSync(opts); });
      chain = own.catch(function () {});
      return own;
    }
    if (queued) { if (!silent) queuedSilent = false; return queued; }
    queuedSilent = !!silent;
    var mine = queued = chain.then(function () {
      queued = null;
      var loud = !queuedSilent;
      return runSync().then(function (wrote) { if (wrote && loud) emit('cart:build'); return wrote; });
    });
    chain = mine.catch(function () {});
    return mine;
  };

  /* ───────────────────────── motion helpers ───────────────────────── */
  function box(el, show, ms) {
    if (calm() || !el || !el.isConnected) return null;
    var cs = getComputedStyle(el), h = el.getBoundingClientRect().height;
    if (!h) return null;
    var full = { height: h + 'px', paddingTop: cs.paddingTop, paddingBottom: cs.paddingBottom, marginTop: cs.marginTop, marginBottom: cs.marginBottom },
        none = { height: '0px', paddingTop: '0px', paddingBottom: '0px', marginTop: '0px', marginBottom: '0px' };
    el.style.overflow = 'hidden'; el.style.boxSizing = 'border-box';
    var a = el.animate(show ? [none, full] : [full, none], { duration: ms || (show ? 440 : 340), easing: show ? EASE : OUT, fill: show ? 'none' : 'forwards' });
    el.animate(show ? [{ opacity: 0 }, { opacity: 0, offset: .3 }, { opacity: 1 }] : [{ opacity: 1 }, { opacity: 0, offset: .6 }, { opacity: 0 }],
      { duration: ms || (show ? 440 : 340), easing: 'linear', fill: show ? 'none' : 'forwards' });
    if (show) a.onfinish = a.oncancel = function () { el.style.overflow = ''; el.style.boxSizing = ''; };
    return a;
  }
  function grow(el) { box(el, true); }
  function fold(el, done) { var a = box(el, false); if (!a) { if (done) done(); return; } a.onfinish = function () { if (done) done(); }; }
  function glide(el, from) {
    if (calm()) return;
    var to = el.getBoundingClientRect().height;
    if (!from || Math.abs(to - from) < 2) return;
    el.style.overflow = 'hidden'; el.style.boxSizing = 'border-box';
    var a = el.animate([{ height: from + 'px' }, { height: to + 'px' }], { duration: 380, easing: EASE });
    a.onfinish = a.oncancel = function () { el.style.overflow = ''; el.style.boxSizing = ''; };
  }
  function rise(el, delay) {
    if (calm() || !el) return;
    el.animate([{ opacity: 0, transform: 'translateY(8px)' }, { opacity: 1, transform: 'none' }], { duration: 420, delay: delay || 0, easing: EASE, fill: 'backwards' });
  }
  function pop(el) {
    if (calm() || !el) return;
    el.animate([{ transform: 'scale(1)' }, { transform: 'scale(1.2)', offset: .4 }, { transform: 'scale(1)' }], { duration: 440, easing: EASE });
  }
  G.pop = pop;

  /* The Gentle roll for any money figure: the old value lifts away, the new one
     rises into place. The ghost is a fixed overlay so nothing else reflows. */
  function rollTo(el, html, fresh) {
    if (!el) return;
    var before = (el.textContent || '').replace(/\s+/g, ' ').trim();
    var r = el.getBoundingClientRect();
    var vis = !calm() && r.width > 0 && r.bottom > 0 && r.top < innerHeight;
    var oldHTML = el.innerHTML;
    if (oldHTML === html) return;
    el.innerHTML = html;
    var after = (el.textContent || '').replace(/\s+/g, ' ').trim();
    if (!vis || before === after) return;
    if (fresh || !before) { var f = D.createElement('span'); f.className = 'gs-roll'; while (el.firstChild) f.appendChild(el.firstChild); el.appendChild(f); rise(f, 60); return; }
    var cs = getComputedStyle(el), block = cs.display !== 'inline';
    var g = D.createElement('div');
    g.className = 'gs-ghost'; g.setAttribute('aria-hidden', 'true'); g.innerHTML = oldHTML;
    ['fontFamily', 'fontSize', 'fontWeight', 'fontStyle', 'letterSpacing', 'lineHeight', 'color', 'textTransform'].forEach(function (p) { g.style[p] = cs[p]; });
    g.style.top = r.top + 'px';
    if (block && /right|end/.test(cs.textAlign)) g.style.right = (D.documentElement.clientWidth - r.right) + 'px';
    else g.style.left = r.left + 'px';
    D.body.appendChild(g);
    var s = D.createElement('span'); s.className = 'gs-roll';
    while (el.firstChild) s.appendChild(el.firstChild);
    el.appendChild(s);
    var a = g.animate([{ opacity: 1, transform: 'none' }, { opacity: 0, transform: 'translateY(-8px)' }], { duration: 300, easing: OUT, fill: 'forwards' });
    a.onfinish = function () { g.remove(); };
    setTimeout(function () { if (g.parentNode) g.remove(); }, 1000);
    s.animate([{ opacity: 0, transform: 'translateY(8px)' }, { opacity: 1, transform: 'none' }], { duration: 420, delay: 90, easing: EASE, fill: 'backwards' });
  }
  G.rollTo = rollTo;
  G.grow = grow; G.fold = fold; G.rise = rise; G.calm = calm;   /* V153: shared with gob-experience.js */

  /* ───────────────────────── 2. drawer morph ───────────────────────── */
  function deco(el) { return !el.hasAttribute('data-key') && /(^|\s)gob-/.test(typeof el.className === 'string' ? el.className : ''); }
  function keyOf(el) {
    if (!el || el.nodeType !== 1) return null;
    var k = el.getAttribute('data-key') || el.getAttribute('data-gs-key');
    if (k) return 'k:' + k;
    if (deco(el)) return null;
    return 't:' + el.tagName + '.' + (typeof el.className === 'string' ? el.className : '');
  }
  function srcBase(u) { return (u || '').split('?')[0].replace(/^https?:/, ''); }
  /* rows that arrive while the drawer is open should not replay the theme's
     image fade — the row itself moves */
  function quiet(n) {
    n.classList.add('gs-q');
    if (n.hasAttribute('data-aos')) n.classList.add('aos-animate');
    qa('[data-aos]', n).forEach(function (e) { e.classList.add('aos-animate'); });
  }
  function keepImage(o, n) {
    var oi = q('.cart__image', o), ni = q('.cart__image', n);
    if (!oi || !ni || o.classList.contains('gs-pending')) return;
    var a = q('img', oi), b = q('img', ni);
    if (a && b && srcBase(a.getAttribute('src')) === srcBase(b.getAttribute('src'))) ni.replaceWith(oi);
  }
  function morph(host, fresh) {
    var cur = q('.cart__items', host);
    if (!cur) {
      host.innerHTML = ''; host.append(fresh);
      [].slice.call(fresh.children).forEach(function (c) { c.__gsHtml = c.outerHTML; });
      return 0;
    }
    [].slice.call(cur.attributes).forEach(function (a) { if (!fresh.hasAttribute(a.name)) cur.removeAttribute(a.name); });
    [].slice.call(fresh.attributes).forEach(function (a) { if (cur.getAttribute(a.name) !== a.value) cur.setAttribute(a.name, a.value); });

    var olds = {};
    [].slice.call(cur.children).forEach(function (el) { var k = keyOf(el); if (k && !olds[k]) olds[k] = el; });
    var kids = [].slice.call(fresh.children);

    /* the "Adding…" row becomes the real row for the same variant */
    var pend = olds['k:gs-pending'];
    if (pend) {
      var pv = pend.getAttribute('data-variant-id');
      var match = kids.filter(function (n) { return n.getAttribute('data-variant-id') === pv && !olds[keyOf(n)]; })[0];
      if (match) { olds[keyOf(match)] = pend; delete olds['k:gs-pending']; }
    }

    var next = [], entering = [], swaps = [];
    kids.forEach(function (n) {
      var k = keyOf(n), html = n.outerHTML, o = k && olds[k];
      if (o) {
        delete olds[k];
        if (o.__gsHtml === html) next.push(o);
        else {
          n.__gsHtml = html; keepImage(o, n); quiet(n);
          swaps.push({ o: o, n: n, h: o.getBoundingClientRect().height });
          next.push(n);
        }
        for (var d = o.nextElementSibling; d && deco(d); d = d.nextElementSibling) next.push(d);
      } else { n.__gsHtml = html; quiet(n); next.push(n); entering.push(n); }
    });
    var leaving = Object.keys(olds).map(function (k) { return olds[k]; });
    leaving.slice().forEach(function (o) { for (var d = o.nextElementSibling; d && deco(d); d = d.nextElementSibling) leaving.push(d); });

    var leaveSet = new Set(leaving), nextSet = new Set(next), ref = cur.firstElementChild;
    next.forEach(function (n) {
      while (ref && leaveSet.has(ref)) ref = ref.nextElementSibling;
      if (ref === n) { ref = ref.nextElementSibling; return; }
      cur.insertBefore(n, ref);
    });
    [].slice.call(cur.children).forEach(function (c) { if (!nextSet.has(c) && !leaveSet.has(c)) c.remove(); });

    swaps.forEach(function (s) {
      if (s.o.classList.contains('gs-pending')) {
        glide(s.n, s.h);
        if (!calm()) s.n.animate([{ opacity: .35 }, { opacity: 1 }], { duration: 380, easing: EASE });
        return;
      }
      glide(s.n, s.h);
      var op = q('.cart__item-price-col', s.o), np = q('.cart__item-price-col', s.n);
      if (op && np && op.textContent.replace(/\s+/g, '') !== np.textContent.replace(/\s+/g, '')) rise(np, 60);
      var oq = q('.js-qty__num', s.o), nq = q('.js-qty__num', s.n);
      if (oq && nq && oq.value !== nq.value) rise(nq, 0);
    });
    entering.forEach(grow);
    leaving.forEach(function (o) { o.classList.add('gs-leaving'); fold(o, function () { o.remove(); }); });
    return leaving.length && !calm() ? 340 : 0;
  }

  /* ───────────────────────── 3. add to cart ───────────────────────── */
  function btnState(btn, st) {
    [btn, q('[data-sticky-add]')].filter(Boolean).forEach(function (b) {
      clearTimeout(b.__gsT);
      var m = q(':scope > .gs-msg', b);
      if (!st) { b.classList.remove('gs-adding', 'gs-added', 'gs-leave'); b.removeAttribute('aria-busy'); if (m) m.remove(); return; }
      if (!b.classList.contains('gs-adding') && !b.classList.contains('gs-added')) {
        var bc = getComputedStyle(b);
        b.style.setProperty('--gs-fg', bc.color);
        if (bc.position === 'static') b.style.position = 'relative';
      }
      if (!m) { m = D.createElement('span'); m.className = 'gs-msg'; m.setAttribute('role', 'status'); b.appendChild(m); }
      b.classList.remove('gs-leave');
      b.classList.toggle('gs-adding', st === 'adding');
      b.classList.toggle('gs-added', st === 'added');
      m.innerHTML = st === 'adding' ? 'Adding…' : '<svg viewBox="0 0 16 16" aria-hidden="true"><path d="M3 8.5l3.2 3L13 4.8"/></svg>Added';
      if (st === 'adding') b.setAttribute('aria-busy', 'true'); else b.removeAttribute('aria-busy');
      if (st === 'added') b.__gsT = setTimeout(function () {
        b.classList.add('gs-leave');
        b.__gsT = setTimeout(function () {
          b.classList.remove('gs-adding', 'gs-added', 'gs-leave');
          var x = q(':scope > .gs-msg', b); if (x) x.remove();
        }, 280);
      }, 1700);
    });
  }
  function prodInfo(f) {
    var sec = f.closest('[data-section-type="product"], [data-product-id], .product-section') || D;
    var t = q('[data-product-title], .product-single__title', sec) || q('h1', sec) || q('h1');
    var title = t ? t.textContent.replace(/\s+/g, ' ').trim() : '';
    var img = '', srcset = '';
    var og = q('meta[property="og:image:secure_url"]') || q('meta[property="og:image"]');
    if (og && og.content) {
      var u = og.content.replace(/^https?:/, ''), base = u.split('?')[0], v = (u.match(/[?&]v=(\d+)/) || [])[1];
      var pre = base + '?' + (v ? 'v=' + v + '&' : '') + 'width=';
      img = pre + '360'; srcset = [180, 360, 540].map(function (w) { return pre + w + ' ' + w + 'w'; }).join(', ');
    }
    var r = q('[data-variant-input]:checked', sec), ver = r ? (r.value || '') : '';
    if (!ver) { var s = q('select[name="id"]', f); if (s && s.selectedOptions && s.selectedOptions[0]) ver = s.selectedOptions[0].textContent.trim(); }
    if (/default title/i.test(ver)) ver = '';
    return { title: title, img: img, srcset: srcset, version: ver };
  }
  function pending(f, vid) {
    var hc = D.getElementById('HeaderCart');
    if (!hc) return null;
    var list = q('[data-products] .cart__items', hc) || q('.cart__items', hc);
    var form = q('form', hc), wrap = form ? form.parentNode : hc;
    var info = { wrap: wrap, wasEmpty: wrap.classList.contains('is-empty'), row: null, existing: null, opened: false };
    var ex = vid && list && q('.cart__item[data-variant-id="' + vid + '"]', list);
    if (ex) { ex.classList.add('gs-busy'); info.existing = ex; }
    else if (list) {
      var p = prodInfo(f), r = D.createElement('div');
      r.className = 'cart__item gs-pending';
      r.setAttribute('data-gs-key', 'gs-pending');
      r.setAttribute('data-variant-id', vid || '');
      r.setAttribute('aria-busy', 'true');
      r.innerHTML =
        '<div class="cart__image"><span class="image-wrap gs-pending__img">' +
          (p.img ? '<img src="' + esc(p.img) + '" srcset="' + esc(p.srcset) + '" sizes="100px" alt="">' : '') +
        '</span></div>' +
        '<div class="cart__item-details"><div class="cart__item-title"><span class="cart__item-name">' + esc(p.title) + '</span>' +
          (p.version ? '<div class="cart__item--variants"><div>' + esc(p.version) + '</div></div>' : '') +
        '</div><div class="cart__item-sub"><span class="gs-pending__note">Adding to your cart…</span></div></div>';
      list.insertBefore(r, list.firstChild);
      info.row = r;
      if (info.wasEmpty) { wrap.classList.remove('is-empty'); wrap.classList.add('gs-new'); }
      wrap.classList.add('gs-wait');
      grow(r);
    }
    if (!H.classList.contains('cart-open')) { info.opened = true; emit('cart:open'); }
    return info;
  }
  function unpend(info) {
    if (!info) return;
    if (info.existing) info.existing.classList.remove('gs-busy');
    info.wrap.classList.remove('gs-wait', 'gs-new');
    if (info.row) {
      var r = info.row;
      fold(r, function () { r.remove(); if (info.wasEmpty && !q('.cart__item[data-key]', info.wrap)) info.wrap.classList.add('is-empty'); });
    }
    if (info.opened) setTimeout(function () { emit('cart:close'); if (W.gobCloseCart) W.gobCloseCart(); }, 350);
  }
  function unveil() {
    qa('#HeaderCart .gs-wait').forEach(function (w) {
      if (q('.gs-pending', w)) return;          /* the paint that replaces it will unveil */
      w.classList.remove('gs-wait', 'gs-new');
      var sub = q('[data-subtotal]', w);
      if (sub) rise(sub, 40);
    });
  }
  function showError(f, err) {
    var msg = err && (typeof err.description === 'string' && err.description ? err.description : (err.message || ''));
    if (!msg) msg = 'Sorry, that did not go through. Please try again.';
    var old = q('.errors', f); if (old) old.remove();
    var d = D.createElement('div'); d.className = 'errors text-center'; d.textContent = msg; f.append(d);
    f.dispatchEvent(new CustomEvent('ajaxProduct:error', { detail: { errorMessage: msg }, bubbles: true }));
  }
  function add(f) {
    if (f.__gsBusy) return;
    f.__gsBusy = true;
    var btn = q('.add-to-cart, [data-add-to-cart]', f);
    var vid = (q('[name="id"]', f) || {}).value;
    emit('gob:will-add', { form: f });   /* V153: read positions before anything moves */
    var data = W.theme.utils.serialize(f);
    G.lastAdd = Date.now();
    btnState(btn, 'adding');
    var pend = pending(f, vid);
    emit('gob:adding', { form: f, row: pend && pend.row, existing: pend && pend.existing });   /* V153: fly-to-cart */
    var pre = readCart(), w0 = G.writes || 0;     /* read the add-ons while the kit is being added */
    fetch(routes().add, {
      method: 'POST', body: data, credentials: 'same-origin',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded', 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (!res || res.status === 422 || res.status === 404 || res.status === 'bad_request' || (!res.id && !res.items)) throw res || {};
        return res;
      })
      .then(function (product) {
        f.__gsBusy = false; G.lastAdd = Date.now();
        /* The kit row paints now; the add-ons go in alongside. The subtotal stays
           veiled until they are in, so it only ever shows one, true number. */
        G.hold = true;
        var sync = G.syncAddons(true, { cart: pre, real: true, later: true, w0: w0 });
        sync.then(function (wrote) { G.hold = false; if (wrote) emit('cart:build'); else unveil(); },
                  function () { G.hold = false; unveil(); });
        var tm = D.getElementById('checkout_timer');
        if (tm && getComputedStyle(tm).display === 'none') { tm.style.display = 'block'; grow(tm); }
        var er = q('.errors', f); if (er) er.remove();
        btnState(btn, 'added');
        f.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: product, addToCartBtn: btn }, bubbles: true }));
      })
      .catch(function (err) {
        f.__gsBusy = false;
        btnState(btn, null);
        unpend(pend);
        showError(f, err);
      });
  }
  /* The theme binds its add-to-cart handler to each form when the section
     loads, so this listens one step earlier (capture on document) and takes
     over the main product form only. Quick add, the cart page and anything
     unusual keep the theme's own flow. */
  function ours(f) {
    if (!f || f.nodeName !== 'FORM') return false;
    if ((f.getAttribute('action') || '').indexOf('/cart/add') < 0) return false;
    if (!W.theme || !W.theme.utils || !W.theme.utils.serialize || !W.theme.CartForm) return false;
    if (D.body.classList.contains('template-cart') || !D.getElementById('HeaderCart')) return false;
    if (W.theme.settings && W.theme.settings.cartType && W.theme.settings.cartType !== 'dropdown') return false;
    if (f.closest('.modal, [id*="QuickAdd"], [id*="QuickShop"], .quick-add-modal, #HeaderCart')) return false;
    return !!q('.add-to-cart, [data-add-to-cart]', f);
  }
  D.addEventListener('submit', function (e) {
    var f = e.target;
    if (e.defaultPrevented || !ours(f)) return;
    e.preventDefault(); e.stopImmediatePropagation(); e.stopPropagation();
    add(f);
  }, true);

  /* ───────────────────────── theme patches ───────────────────────── */
  function patch() {
    var T = W.theme;
    if (!T || !T.CartForm || G.patched) return;
    G.patched = true;

    /* every old add-on entry point → the one queue */
    T.updateShippingInsurance = function () { return G.syncAddons(); };
    T.updateExtendedWarranty = function () { return G.syncAddons(); };
    var oAttr = T.submitCartAttribute;
    T.submitCartAttribute = function (name) {
      if (name === 'wf-switch' || name === 'xw-switch') return G.syncAddons();
      return oAttr ? oAttr.apply(this, arguments) : Promise.resolve();
    };

    var P = T.CartForm.prototype;
    var oCount = P.updateCount;
    P.updateCount = function (count) {
      var was = qa('.cart-link__bubble-num').map(function (e) { return e.textContent; });
      oCount.call(this, count);
      qa('.cart-link__bubble-num').forEach(function (e, i) { if (was[i] !== undefined && was[i] !== e.textContent) pop(e.closest('.cart-link__bubble') || e); });
    };
    /* kept rows keep their quantity buttons; only new rows get new ones */
    P.initQtySelectors = function () {
      var s = this;
      qa('.js-qty__wrapper', this.form).forEach(function (el) {
        if (el.__gsQty) return; el.__gsQty = 1;
        new T.QtySelector(el, { namespace: s.namespace, isCart: true });
      });
    };
    /* a burst of cart:build / cart:updated / redraw calls = one fetch, one paint */
    P.buildCart = function () {
      var s = this;
      if (s.__gsQ) { s.__gsDirty = true; return; }
      s.__gsQ = true;
      var skips = 0;
      function finish() { s.__gsQ = false; if (s.__gsDirty) { s.__gsDirty = false; s.buildCart(); } }
      function run() {
        s.__gsDirty = false;
        T.cart.getCartProductMarkup().then(function (text) {
          if (s.__gsDirty && skips++ < 2) return run();       /* a newer change is on its way: skip the stale paint */
          if (text) { try { s.cartMarkup(text); } catch (e) {} }
          finish();
        }, finish);
      }
      setTimeout(run, 30);
    };
    var oMarkup = P.cartMarkup;
    P.cartMarkup = function (text) {
      var m;
      try { m = this._parseProductHTML(text); } catch (e) { return oMarkup.call(this, text); }
      if (!m || !m.items || !this.products || !this.subtotal) return oMarkup.call(this, text);
      var items = m.items, count = parseInt(items.dataset.count, 10) || 0, self = this;
      this.updateCartDiscounts(m.discounts);
      this.updateSavings(items.dataset.cartSavings);
      if (count > 0) this.wrapper.classList.remove('is-empty');
      this.updateCount(count);
      var wait = morph(this.products, items);
      if (!(count > 0)) {   /* V153: the footer bows out first, the empty state follows the last fold */
        this.wrapper.classList.add('gs-emptying');
        setTimeout(function () { self.wrapper.classList.add('is-empty'); self.wrapper.classList.remove('gs-emptying'); }, wait);
      }
      var fresh = this.wrapper.classList.contains('gs-wait');
      if (!G.hold) this.wrapper.classList.remove('gs-wait', 'gs-new');
      rollTo(this.subtotal, T.Currency.formatMoney(items.dataset.cartSubtotal, T.settings.moneyFormat), fresh);
      G.syncAddons();
      this.initQtySelectors();
      try { if (W.AOS && q('[data-aos]:not(.aos-animate)', this.products)) W.AOS.refreshHard(); } catch (e) {}
      try { if (W.Shopify && Shopify.StorefrontExpressButtons) Shopify.StorefrontExpressButtons.initialize(); } catch (e) {}
      emit('gob:cart-painted', { count: count });
    };
  }
  /* The drawer footer gains rows after a paint (Club offer, monthly draw,
     trust line — added by other scripts). Let it glide to its new height
     instead of jumping. */
  function footerGlide() {
    if (!W.ResizeObserver) return;
    var f = q('#HeaderCart .cart__footer');
    if (!f || f.__gsRO) return;
    f.__gsRO = 1;
    var last = 0, busy = false;
    new ResizeObserver(function () {
      if (busy) return;
      var h = f.getBoundingClientRect().height;
      var from = last; last = h;
      if (!from || Math.abs(h - from) < 4 || calm() || !H.classList.contains('cart-open')) return;
      busy = true;
      f.style.overflow = 'hidden'; f.style.boxSizing = 'border-box';
      var a = f.animate([{ height: from + 'px' }, { height: h + 'px' }], { duration: 380, easing: EASE });
      a.onfinish = a.oncancel = function () { f.style.overflow = ''; f.style.boxSizing = ''; busy = false; last = f.getBoundingClientRect().height; };
    }).observe(f);
  }
  if (D.readyState === 'loading') D.addEventListener('DOMContentLoaded', footerGlide); else footerGlide();

  if (W.theme && W.theme.CartForm) patch();
  else D.addEventListener('DOMContentLoaded', patch);
})();
